import { Dimensions, Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
    regular: {
        fontFamily: 'Comfortaa-Regular',
    },
    bold: {
        fontFamily: 'Comfortaa-Bold',
    },
    form: {
        backgroundColor: 'white',
        marginBottom: 25
      },
    formContainer: {
        paddingHorizontal: 15,
        paddingVertical: 20,
        flex: 1,
        flexDirection: 'row',
        flexWrap: 'wrap'
      },
      columnFormContainer: {
        paddingHorizontal: 15,
        paddingVertical: 20,
        flex: 1
      },
      formTitle: {
        color: '#461b6f',
        textAlign: 'center',
        padding: 12,
        fontSize: Dimensions.get('window').width>=768?18:16
      },
      formSubtitle: {
        color: '#461b6f',
        textDecorationLine: 'underline'
      },
      formRow: {
        // display: 'flex',
        // flexDirection: 'row',
        // alignItems: 'center',
        // marginBottom: 10,
        // width: Dimensions.get('window').width>=768?'48%':'100%',
        // marginRight: Dimensions.get('window').width>=768?'2%':0
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: Dimensions.get('window').width>=768?'50%':'100%',
        paddingHorizontal: Dimensions.get('window').width>=576?'5vw':0,
      },
      formTextareaRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 10,
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: '100%',
        paddingHorizontal: Dimensions.get('window').width>=576?'5vw':0,
      },
      doubleInput: {
        display: 'flex',
        flexDirection: 'row',
      },
      secondInput: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 65
      },
      formRowLabel: {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: 110,
        paddingRight: 10
      },
      formRowInput: {
        flex: 1,
        width: '100%',
      },
      title: {
        color: '#461b6f',
        marginBottom: 3,
        fontSize: Dimensions.get('window').width>=768?24:22
      },
      subtitle: {
        marginBottom: 15
      },
      background: {
        flex: 1,
        backgroundColor: '#F6F4F9',
        paddingTop: 15,
        paddingHorizontal: 20,
        paddingBottom: 70,
        overflow: 'visible'
      },
      button: {
        paddingVertical: 10,
        paddingHorizontal: 30,
        backgroundColor: '#461b6f',
        color: 'white',
        borderRadius: 12,
        overflow: 'hidden',
        textAlign: 'center'
      },
      smallButton: {
        // flex: 1,
        height: 35,
        // lineHeight: 33,
        justifyContent: 'center',
        alignItems: 'center',
        // paddingHorizontal: 20,
        // paddingVertical: 10,
        borderColor: '#461b6f',
        color: '#461b6f',
        borderWidth: 0.5,
        backgroundColor: 'white',
        borderRadius: 8,
        // textAlign: 'center',
        overflow: 'hidden',
        cursor: 'pointer'
      },
      smallButtonText: {
        textAlign: 'center',
        // paddingBottom: 5
      },
      filterButton: {
          marginRight: 10,
          marginBottom: 10,
          flexBasis: 125,
          flexGrow: 0,
          flexShrink: 0,
          // height: 33,
      },
      fullFilterButton: {
          marginRight: 10,
          marginBottom: 10,
          flexBasis: 260,
          flexGrow: 0,
          flexShrink: 0
      },

      xxs: {
        fontSize: Dimensions.get('window').width>=768?9:7
      },
      xs: {
        fontSize: Dimensions.get('window').width>=768?10:8
      },
      s: {
        fontSize: Dimensions.get('window').width>=768?12:10
      },
      sm: {
        fontSize: Dimensions.get('window').width>=768?14:12
      },
      m: {
        fontSize: Dimensions.get('window').width>=768?16:14
      },
      ml: {
        fontSize: Dimensions.get('window').width>=768?18:16
      },
      l: {
        fontSize: Dimensions.get('window').width>=768?20:18
      },
      xl: {
        fontSize: Dimensions.get('window').width>=768?24:22
      },
      xxl: {
        fontSize: Dimensions.get('window').width>=768?34:34
      },
});